<template>
  <div class="container-fluid">
    <organization-form
      :loading="loading"
      :organizationData="organization"
      :formErrors="formErrors"
      @organizationSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import defaultTaxes from "@/constants/defaultTaxes";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultOrganization from "../defaultOrganization";
import OrganizationForm from "../partials/OrganizationForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    OrganizationForm,
  },

  mixins: [alertLeave],

  data() {
    const organization = cloneDeep(defaultOrganization);
    organization.taxes = cloneDeep(defaultTaxes);
    return {
      organization: organization,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(organization) {
      this.loading = true;

      const organizationData = cloneDeep(organization);
      delete organizationData.id;

      try {
        await this.$store.dispatch("organizations/add", organizationData);
        this.$notify({
          type: "success",
          message: this.$t("ORGANIZATIONS.ORGANIZATION_ADDED"),
        });
        const organization = await this.$store.getters[
          "organizations/organization"
        ];
        this.$emit("onViewOrganization", organization, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
